const configBoardFilter = {
    notice: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr_type: 'post',
        },
        pageRow: 10,
        deleteFunc: 'deleteNotice',
        deleteApiParamSet: {
            wr_type: 'post',
        },
        deleteKeyName: 'wr_id',
    },
    noticeCreate: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
            wr_type: 'post',
        },
        subFunc: 'createNotice',
        parsingData: {
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {
            wr_type: 'post',
        },
        resultAlertTxt: '공지사항이 등록되었습니다.',
        directUrl: 'back',
    },
    noticeUpdate: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
            wr_type: 'post',
        },
        subFunc: 'updateNotice',
        parsingData: {
            id: 'wr_id',
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {
            wr_type: 'post',
        },
        resultAlertTxt: '공지사항이 수정되었습니다.',
        directUrl: '',
    },
    faq: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr_type: 'post',
        },
        pageRow: 10,
        deleteFunc: 'deleteFaq',
        deleteApiParamSet: {
            wr_type: 'post',
        },
        deleteKeyName: 'fa_idx',
    },
    faqCreate: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: 'createFaq',
        parsingData: {
            title : 'fa_subject',
            content : 'fa_content',
            country: 'c_idx',
        },
        createApiParamSet: {

        },
        resultAlertTxt: 'FAQ가 등록되었습니다.',
        directUrl: 'back',
    },
    faqUpdate: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: 'updateFaq',
        parsingData: {
            id: 'fa_idx',
            title : 'fa_subject',
            content : 'fa_content',
            country: 'c_idx',
        },
        createApiParamSet: {
        },
        resultAlertTxt: 'FAQ가 수정되었습니다.',
        directUrl: '',
    },
    refund: {
        getFunc: 'getRefund',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            r_type: 'question',
            opa: 1,
            opw: 1,
        },
        pageRow: 10,
        deleteFunc: null,
        deleteApiParamSet: {},
        deleteKeyName: null,
    },
    refundAnswer: {
        getCategoryFunc: null,
        getFunc: 'getRefund',
        createFunc: 'createRefundAnswer',
        updateFunc: 'updateRefundAnswer',
        detailApiParamSet: {
            ip: 0,
            r_type: 'question',
            opa: 1,
            opw: 1,
        },
        parsingData: {
            id : 'wr_parent',
            answerTitle : 'wr_subject',
            answerContent : 'wr_content',
            status: 'ri_status',
        },
        createApiParamSet: {
            r_type: 'answer'
        },
        answerKeyName: 'wr_id',
    },
    qa: {
        getFunc: 'getQa',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            qq_type: 'member',
        },
        pageRow: 10,
        deleteFunc: null,
        deleteApiParamSet: {},
        deleteKeyName: null,
    },
    qaAnswer: {
        getCategoryFunc: null,
        getFunc: 'getQa',
        createFunc: 'createQaAnswer',
        updateFunc: 'updateQaAnswer',
        detailApiParamSet: {
            ip: 0,
            qq_type: 'member',
            opd: 1,
        },
        parsingData: {
            id : 'qq_idx',
            answerTitle : 'qa_subject',
            answerContent : 'qa_content',
        },
        createApiParamSet: {
            qa_type: 'answer'
        },
        answerKeyName: 'qa_idx',
    },
}

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        }
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'searchInput',
        },
        co: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
        cid: {
            type: 'match',
            classname: 'filterCountry'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        pa: {
            type: 'query',
            classname: 'searchInput',
        },
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
    }
}
